export class ConnectionsFakeDb {
  public static connections = {
    memberships: [
        {
            "invite_id": "",
            "account_id": "6c3e8a63-d8c2-4b78-a8d9-d7f923253c96",
            "account_name": "J.A WIFFEN & K.J WIFFEN",
            "trading_name": "J.A WIFFEN & K.J WIFFEN",
            "account_logo": "https://devdoc.gravityfusion.com.au/logo/6c3e8a63-d8c2-4b78-a8d9-d7f923253c96.jpg?1755667793508",
            "account_abn": "72693808408",
            "contact_name": "Test Member 1",
            "contact_email": "t+1@mail.com",
            "contact_phone": "+61 412 858 585",
            "account_address": "",
            "role": "DirectResource",
            "status": "Active",
            "date_label": "Since Active",
            "date": "2025-12-12T07:39:17.744Z",
            "resource_status": "Active",
            "styleStatus": "active"
        },
        {
            "invite_id": "",
            "account_id": "f376dd3e-4caa-49c9-ada7-695b9f033295",
            "account_name": "The Trustee for JB & TA FERGUSON FAMILY TRUST",
            "trading_name": "The Trustee for JB & TA FERGUSON FAMILY TRUST",
            "account_logo": "https://devdoc.gravityfusion.com.au/logo/f376dd3e-4caa-49c9-ada7-695b9f033295.png?1756694453572",
            "account_abn": "90328219319",
            "contact_name": "Test Member 2",
            "contact_email": "t+2@mail.com",
            "contact_phone": "+61412101102",
            "account_address": "101 Little Collins St, Melbourne VIC 3004, Australia",
            "role": "Administrator",
            "status": "Active",
            "date_label": "Since Active",
            "date": "2023-04-17T23:46:04.878Z",
            "resource_status": "Active",
            "styleStatus": "active"
        },
        {
            "invite_id": "",
            "account_id": "e1932bb8-5881-467c-ac79-ff9cb113c456",
            "account_name": "C R & E PTY LTD",
            "trading_name": "",
            "account_logo": "",
            "account_abn": "26163015110",
            "contact_name": "Test Member 3",
            "contact_email": "t+3@mail.com",
            "contact_phone": "+61412101103",
            "account_address": "Sydney Rd, Campbellfield VIC 3061, Australia",
            "role": "Administrator",
            "status": "Active",
            "date_label": "Since Active",
            "date": "2026-01-19T10:00:28.102Z",
            "resource_status": "Active",
            "styleStatus": "active"
        }
    ],
    "invitations": [],
    "external_manage_invitations": [
        {
            "invite_id": "4592a476-28c3-4a22-ae94-533dadc1382c",
            "account_id": "e1932bb8-5881-467c-ac79-ff9cb113c456",
            "account_name": "C R & E PTY LTD",
            "trading_name": "",
            "account_logo": "",
            "account_abn": "26163015110",
            "contact_name": "Test External 1",
            "contact_email": "te+1@mail.com",
            "contact_phone": "2151542456",
            "account_address": "Address2",
            "role": "External Manager",
            "status": "Active",
            "date_label": "Received",
            "date": "2026-01-15T11:02:40.187Z"
        },
        {
            "invite_id": "4592a476-28c3-4a22-ae94-533dadc1382c",
            "account_id": "e1932bb8-5881-467c-ac79-ff9cb113c456",
            "account_name": "C R & E PTY LTD",
            "trading_name": "",
            "account_logo": "",
            "account_abn": "26163015110",
            "contact_name": "Test External 2",
            "contact_email": "te+2@mail.com",
            "contact_phone": "2151542456",
            "account_address": "Address2",
            "role": "External Manager",
            "status": "Active",
            "date_label": "Received",
            "date": "2026-01-15T11:02:40.187Z"
        },
        {
            "invite_id": "b9575611-9e62-464d-ac87-12c941428996",
            "account_id": "c993c664-a284-46b6-b2f7-7f3f2ab2947c",
            "account_name": "EVANS, CHRISTOPHER ROY",
            "trading_name": "",
            "account_logo": "",
            "account_abn": "37695172507",
            "contact_name": "Test External 3",
            "contact_email": "te+3@mail.com",
            "contact_phone": "+40746125549",
            "account_address": "Bd Opa",
            "role": "External Manager",
            "status": "Failed",
            "date_label": "Received",
            "date": "2026-01-15T11:30:53.793Z",
            "styleStatus": "failed"
        },
        {
            "invite_id": "bb54a380-cf61-4daa-8595-dfd5a1e95fa5",
            "account_id": "dab60771-4b78-4827-87e9-5ac0c4c008a3",
            "account_name": "HARCO PROPERTY GROUP PTY LTD",
            "trading_name": "",
            "account_logo": "",
            "account_abn": "69639277277",
            "contact_name": "Test External 4",
            "contact_email": "te+4@mail.com",
            "contact_phone": "+40746125549",
            "account_address": "Bd Opa",
            "role": "External Manager",
            "status": "Failed",
            "date_label": "Received",
            "date": "2026-01-22T11:24:26.696Z",
            "styleStatus": "failed"
        },
        {
            "invite_id": "0a0e4d32-bc2d-413f-a02f-d95b9ff22f5f",
            "account_id": "6ef25cbf-42e6-4fe6-8221-cb0fd0389a6d",
            "account_name": "The Trustee for Zi",
            "trading_name": "",
            "account_logo": "",
            "account_abn": "55246878352",
            "contact_name": "Test External 5",
            "contact_email": "te+5@mail.com",
            "contact_phone": "+40754791732",
            "account_address": "Strada Iuliu Moldovan, Cluj-Napoca, Romania",
            "role": "External Manager",
            "status": "Failed",
            "date_label": "Received",
            "date": "2026-01-21T10:22:03.129Z",
            "styleStatus": "failed"
        },
        {
            "invite_id": "95de6d7e-b379-4d38-b43d-ec5919b6b669",
            "account_id": "c9907832-1148-42c4-936d-963eecc81dd3",
            "account_name": "The trustee for Prates-Cowan Family Trust",
            "trading_name": "",
            "account_logo": "",
            "account_abn": "64150921802",
            "contact_name": "Test External 6",
            "contact_email": "te+6@mail.com",
            "contact_phone": "+40746125549",
            "account_address": "Str. Vlădești, Avrămeşti, Romania",
            "role": "External Manager",
            "status": "Waiting For Approval",
            "date_label": "Received",
            "date": "2026-01-26T12:15:38.598Z",
            "styleStatus": "waiting"
        },
        {
            "invite_id": "adba87b3-b03b-4c7d-98d7-583a07a16166",
            "account_id": "1754c5ee-5589-43a9-b9b2-776e5be796f1",
            "account_name": "DENN, ELLYCE MARIE",
            "trading_name": "",
            "account_logo": "",
            "account_abn": "11283251728",
            "contact_name": "Test External 7",
            "contact_email": "te+7@mail.com",
            "contact_phone": "+40746125549",
            "account_address": "Str. Vlădești, Avrămeşti, Romania",
            "role": "External Manager",
            "status": "Pending",
            "date_label": "Received",
            "date": "2026-01-26T12:32:12.756Z",
            "styleStatus": "pending"
        }
    ]

  }
}
